import { styled } from 'styled-components';
import {
  Button,
  FormFieldLabel,
  ListItem,
  SheetContentWrapper,
  SpaceBetween,
  tk,
  Typography,
} from '@sunwebgroup/ui-components';
import * as Popover from '@radix-ui/react-popover';

export const ParticipantName = styled(ListItem.Label)`
  ${Typography.modVariant('body-sm')}
  color: ${tk('color_semantic_text')};
`;
export const OptionSelectedTitle = styled(ListItem.Label)`
  color: ${tk('color_semantic_text')};
  line-height: ${tk('font_line_height_md')};
`;
export const DurationSelected = styled(ListItem.Label)`
  ${Typography.modVariant('body-sm')}
  color: ${tk('color_semantic_text_subdued')};
`;
export const SheetParticipantName = styled(Typography)`
  color: ${tk('color_semantic_text')};
`;
export const SheetDescription = styled(Typography)`
  color: ${tk('color_semantic_text')};
`;
export const SheetFilterLabel = styled(FormFieldLabel)`
  color: ${tk('color_semantic_text')};
`;
export const PopoverTrigger = styled(Popover.PopoverTrigger)`
  cursor: pointer;
  display: block;
  padding: ${tk('spacing_sm')};
  width: auto;
  margin: 0 auto;
  background-color: ${tk('color_semantic_bg')};
  border: 2px solid ${tk('color_semantic_border')};
  border-radius: ${tk('radius_rounded')};

  ${Typography} {
    line-height: ${tk('font_line_height_md')};
  }

`;
export const PopoverContent = styled(Popover.PopoverContent)`
  background: ${tk('color_semantic_bg')};
  border-radius: ${tk('spacing_xs')};
  box-shadow: ${tk('shadow_lg_bottom')};
  color: ${tk('color_semantic_text')};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: ${tk('spacing_xs')};
  @media ${tk('mq_desktop_sm')} {
    min-width: 320px;
  }
  ${Button} {
    margin: ${tk('spacing_none')};
    justify-content: left;
    border-radius: ${tk('spacing_xs')};

    &:hover {
      background-color: ${tk('color_semantic_bg_subdued')};
    }
  }
`;
export const SkiAncillaryContent = styled(SheetContentWrapper)`
  padding: ${tk('spacing_md')};
`;
export const Price = styled(Typography)`
  color: ${tk('color_semantic_text')};
  white-space: nowrap;
`;
export const Texts = styled(SpaceBetween)`
  flex: 1;
`;
export const SelectParticipantButton = styled(Button)`
  margin: 0 auto;
`;
export const OpenSheetButton = styled(Button)`
  margin: 0;
  min-width: auto;
  padding: ${tk('spacing_none')};
`
export const PriceBlock = styled.div`
  display: flex;
  align-items: center;
  gap: ${tk('spacing_2xs')};
  @media ${tk('mq_desktop_sm')} {
    gap: ${tk('spacing_xs')};
  }
`;
